<template>
  <div>
    <hxp-crk-census />
  </div>
</template>

<script>
// 获取接口地址
import HxpCrkCensus from '@/components/tjbb/hxpCrkCensus.vue'

export default {
  name: 'Hxpcrktj',
  components: {
    // sideMenu,
    // Header,
    HxpCrkCensus
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
